
import ButterflyIcon from '@/material-icons/400-24px/butterfly.svg?react';
import ChatIcon from '@/material-icons/400-24px/chat.svg?react';
import FacebookIcon from '@/material-icons/400-24px/facebook.svg?react';
import FeedIcon from '@/material-icons/400-24px/feed_icon.svg?react';
import InstagramIcon from '@/material-icons/400-24px/instagram.svg?react';
import LinktreeIcon from '@/material-icons/400-24px/linktree.svg?react';
import MastodonIcon from '@/material-icons/400-24px/mastodon.svg?react';
import MessageIcon from '@/material-icons/400-24px/message.svg?react';
import PenIcon from '@/material-icons/400-24px/pen_icon.svg?react';
import PinterestIcon from '@/material-icons/400-24px/pintrest.svg?react';
import PixelfedIcon from '@/material-icons/400-24px/pixelfed.svg?react';
import PodcastIcon from '@/material-icons/400-24px/podcast.svg?react';
import RedditIcon from '@/material-icons/400-24px/reddit.svg?react';
import RssFeedIcon from '@/material-icons/400-24px/rss_feed.svg?react';
import SnapchatIcon from '@/material-icons/400-24px/snapchat.svg?react';
import ThreadIcon from '@/material-icons/400-24px/thread.svg?react';
import TiktokIcon from '@/material-icons/400-24px/tiktok.svg?react';
import VideoIcon from '@/material-icons/400-24px/video.svg?react';
import WebsiteIcon from '@/material-icons/400-24px/website_icon.svg?react';
import WhatsappIcon from '@/material-icons/400-24px/whatsapp.svg?react';
import XIcon from '@/material-icons/400-24px/x.svg?react';
import type { IconProp } from 'mastodon/components/icon';

export const icons: Record<string, IconProp> = {
  blog: PenIcon,
  bluesky: ButterflyIcon,
  chat: ChatIcon,
  facebook: FacebookIcon,
  feed: FeedIcon,
  instagram: InstagramIcon,
  linktree: LinktreeIcon,
  mastodon: MastodonIcon,
  message: MessageIcon,
  pinterest: PinterestIcon,
  pixelfed: PixelfedIcon,
  podcast: PodcastIcon,
  reddit: RedditIcon,
  rssfeed: RssFeedIcon,
  snapchat: SnapchatIcon,
  thread: ThreadIcon,
  tiktok: TiktokIcon,
  video: VideoIcon,
  website: WebsiteIcon,
  whatsapp: WhatsappIcon,
  x: XIcon,
};
